//Indication of the actions
//Showing what type of interaction is dispatched to store

export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_CURRENT_USER_PERMISSION = "SET_CURRENT_USER_PERMISSION";
